const resumo_da_entrega_dos_relatorios_finais = [
  {
    path: "/resumo-da-entrega-dos-relatorios-finais",
    name: "resumo_da_entrega_dos_relatorios_finais",
    meta: {
      allowedPermissions: ["relatoriofinal_resumo_entrega"],
      breadCrumb: "Processo de Resultado Final - Relatório Final da Escola",
    },
    component: () =>
      import(
        "@/views/ResumoDaEntregraDosRelatoriosFinais/ResumoDaEntregraDosRelatoriosFinais.vue"
      ),
  },
];

export { resumo_da_entrega_dos_relatorios_finais };
